import { render, staticRenderFns } from "./CertificateCard.vue?vue&type=template&id=70a7fc5e&scoped=true&"
import script from "./CertificateCard.vue?vue&type=script&lang=js&"
export * from "./CertificateCard.vue?vue&type=script&lang=js&"
import style0 from "./CertificateCard.vue?vue&type=style&index=0&id=70a7fc5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a7fc5e",
  null
  
)

export default component.exports